export default {
    metadata: {
        extractslocationsLabel: "Relevanter Extrakt",
        extractslocationsPluralLabel: "Relevante Extrakte",
        geoLabel: "Ort",
        geoPluralLabel: "Orte",
        personLabel: "Person",
        personPluralLabel: "Personen",
        companyLabel: "Firma",
        companyPluralLabel: "Firmen",
        treepathLabel: "Quelle",
        treepathPluralLabel: "Quellen",
        matchlocationsLabel: "Suchbegriff",
        matchlocationsPluralLabel: "Suchbegriffe",
        titleLabel: "Titel",
        titlePluralLabel: "Titel",
        authorsLabel: "Autor",
        authorsPluralLabel: "Autoren",
        filenameLabel: "Dateiname",
        filenamePluralLabel: "Dateinamen",
        modifiedLabel: "Datum",
        modifiedPluralLabel: "Datumsangaben",
        sizeLabel: "Größe",
        sizePluralLabel: "Größen",
        docformatLabel: "Format",
        docformatPluralLabel: "Formate",
        documentlanguagesLabel: "Sprache",
        documentlanguagesPluralLabel: "Sprachen",
        geo_label: "Ort",
        geo_plural_label: "Orte",
        person_label: "Person",
        person_plural_label: "Personen",
        company_label: "Firma",
        company_plural_label: "Firmen",
        treepath_label: "Quelle",
        treepath_plural_label: "Quellen",
        title_label: "Titel",
        title_plural_label: "Titel",
        authors_label: "Autor",
        authors_plural_label: "Autoren",
        filename_label: "Dateiname",
        filename_plural_label: "Dateinamen",
        modified_label: "Datum",
        modified_plural_label: "Datumsangaben",
        size_label: "Größe",
        size_plural_label: "Größen",
        docformat_label: "Format",
        docformat_plural_label: "Formate",
        documentlanguages_label: "Sprache",
        documentlanguages_plural_label: "Sprachen",
        accessLists: {
            authorizedListTitleText: "Liste der erlaubten Zugriffe",
            authorizedListHeader: "Liste der erlaubten Zugriffe {value, number}",
            deniedListTitleText: "Liste der unerlaubten Zugriffe",
            deniedListHeader: "Liste der unerlaubten Zugriffe {value, number}"
        },
        item: {
            label: "{label}:",
            separator: " ",
            treeSeparator: " ; ",
            treeNodeSeparator: "/",
            listSeparator: ", ",
            empty_boolean: 'false',
            empty_number: '0'
        }
    }
};
